export default function staticText(key, fallback) {
    try {
        const staticTexts = window.siteConfig().staticTexts;
        if (staticTexts[key] === undefined) throw 'Missing static text';
        return staticTexts[key];
    } catch (e) {
        return fallback ? fallback : key;
    }
}
